'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HoldCounts = require('./components/HoldCounts.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HoldCounts).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/hold-counts/lib/index.js
// module id = 596
// module chunks = 0 9 10 12 13